// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","snackbars":"App_snackbars__2Oi-t"};